import { h } from "@stencil/core";
import { TableCellProps } from "../table-cell";
import { getViewportWidth } from "../../../../utils/getViewportWidth";

export const renderDiscontinuedInfo = ({
    item,
    columnKey,
    schemaItem,
}: TableCellProps) => {
    const isMobile = getViewportWidth() < 768;
    return (
        <td class={schemaItem.className} data-testid={columnKey}>
            <div class="ux-u-d-flex ux-u-flex-ai-center">
                {item.discontinued !== undefined && (
                    <ux-iws-discontinuation-icon
                        tooltip-identifier={item.number}
                        type={item.discontinued.type}
                        status={item.discontinued.status}
                        extended-support={item.discontinued.extendedSupport}
                    ></ux-iws-discontinuation-icon>
                )}
                {item.discontinued !== undefined && !isMobile && (
                    <ux-iws-discontinuation-tooltip
                        tooltip-identifier={item.number}
                        type={item.discontinued.type}
                        status={item.discontinued.status}
                        extended-support={item.discontinued.extendedSupport}
                        head={item.discontinued.head}
                        text={item.discontinued.text}
                        link={item.discontinued.link}
                        link-text={item.discontinued.linkText}
                    ></ux-iws-discontinuation-tooltip>
                )}
                {item[columnKey]}
            </div>
        </td>
    );
};
